import { render, staticRenderFns } from "./ProductsMenu.vue?vue&type=template&id=6512a959&scoped=true&"
import script from "./ProductsMenu.vue?vue&type=script&lang=js&"
export * from "./ProductsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductsMenu.vue?vue&type=style&index=0&id=6512a959&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6512a959",
  null
  
)

export default component.exports